import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PolitiqueConfidentialite() {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-slate-100 py-4 px-6">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/" className="font-heading text-xl font-bold uppercase text-slate-900">COACH.</Link>
          <Link to="/" className="text-sm text-slate-500 hover:text-blue-600 flex items-center gap-1">
            <ArrowLeft className="w-4 h-4" /> Retour
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="font-heading text-3xl font-bold tracking-tight uppercase text-slate-900 mb-8">Politique de Confidentialit&eacute;</h1>

        <div className="space-y-8 text-sm text-slate-600 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Responsable du traitement</h2>
            <p>
              Le responsable du traitement des donn&eacute;es personnelles collect&eacute;es sur la plateforme Coach est
              Anthony Gillet, entrepreneur individuel.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Donn&eacute;es collect&eacute;es</h2>
            <p>Dans le cadre de l'utilisation de la plateforme Coach, nous collectons les donn&eacute;es suivantes :</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li><strong>Donn&eacute;es d'identification :</strong> nom, pr&eacute;nom, adresse email</li>
              <li><strong>Donn&eacute;es de sant&eacute; et forme physique :</strong> poids, mensurations, photos de progression</li>
              <li><strong>Donn&eacute;es de suivi :</strong> programmes d'entra&icirc;nement, plans di&eacute;t&eacute;tiques, historique de progression</li>
              <li><strong>Donn&eacute;es de connexion :</strong> adresse IP, type de navigateur, dates et heures de connexion</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Base l&eacute;gale du traitement</h2>
            <p>Le traitement de vos donn&eacute;es repose sur :</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li><strong>Votre consentement :</strong> lors de la cr&eacute;ation de votre compte et de l'acceptation des pr&eacute;sentes</li>
              <li><strong>L'ex&eacute;cution d'un contrat :</strong> la fourniture du service de coaching entre le coach et l'&eacute;l&egrave;ve</li>
              <li><strong>L'int&eacute;r&ecirc;t l&eacute;gitime :</strong> am&eacute;lioration de la plateforme et s&eacute;curit&eacute;</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Finalit&eacute;s du traitement</h2>
            <p>Vos donn&eacute;es personnelles sont collect&eacute;es pour :</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>La gestion de votre compte utilisateur</li>
              <li>La fourniture des services de coaching (entra&icirc;nement, nutrition, suivi)</li>
              <li>La communication entre coachs et &eacute;l&egrave;ves</li>
              <li>L'am&eacute;lioration de la plateforme et l'analyse d'usage</li>
              <li>Le traitement des paiements et la facturation</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">H&eacute;bergement des donn&eacute;es</h2>
            <p>
              Vos donn&eacute;es sont h&eacute;berg&eacute;es en France par LWS (Ligne Web Services),
              situ&eacute; au 10 Rue de Penthi&egrave;vre, 75008 Paris, France.
              Les donn&eacute;es ne sont pas transf&eacute;r&eacute;es en dehors de l'Union Europ&eacute;enne.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Dur&eacute;e de conservation</h2>
            <p>
              Vos donn&eacute;es personnelles sont conserv&eacute;es pendant toute la dur&eacute;e de votre inscription sur la plateforme,
              puis pendant une dur&eacute;e d'un (1) an apr&egrave;s la suppression de votre compte, conform&eacute;ment aux obligations l&eacute;gales.
            </p>
            <p className="mt-2">
              Les donn&eacute;es de facturation sont conserv&eacute;es pendant dix (10) ans conform&eacute;ment aux obligations comptables.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Vos droits (RGPD)</h2>
            <p>Conform&eacute;ment au R&egrave;glement G&eacute;n&eacute;ral sur la Protection des Donn&eacute;es (RGPD), vous disposez des droits suivants :</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li><strong>Droit d'acc&egrave;s :</strong> obtenir une copie de vos donn&eacute;es personnelles</li>
              <li><strong>Droit de rectification :</strong> corriger des donn&eacute;es inexactes ou incompl&egrave;tes</li>
              <li><strong>Droit &agrave; l'effacement :</strong> demander la suppression de vos donn&eacute;es</li>
              <li><strong>Droit &agrave; la portabilit&eacute; :</strong> recevoir vos donn&eacute;es dans un format structur&eacute;</li>
              <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos donn&eacute;es</li>
              <li><strong>Droit &agrave; la limitation :</strong> demander la limitation du traitement</li>
            </ul>
            <p className="mt-3">
              Pour exercer ces droits, contactez-nous via le formulaire de support accessible depuis la plateforme.
            </p>
            <p className="mt-2">
              Vous pouvez &eacute;galement introduire une r&eacute;clamation aupr&egrave;s de la CNIL (Commission Nationale de l'Informatique et des Libert&eacute;s) :
              {" "}<a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline hover:text-blue-700">www.cnil.fr</a>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Cookies</h2>
            <p>
              La plateforme Coach utilise uniquement des cookies fonctionnels strictement n&eacute;cessaires au bon fonctionnement du site
              (authentification, pr&eacute;f&eacute;rences de session). Aucun cookie publicitaire ou de tra&ccedil;age n'est utilis&eacute;.
            </p>
            <p className="mt-2">
              Vous pouvez g&eacute;rer vos pr&eacute;f&eacute;rences de cookies via le bandeau de consentement affich&eacute; lors de votre premi&egrave;re visite,
              ou en supprimant les cookies depuis les param&egrave;tres de votre navigateur.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">Modification de la politique</h2>
            <p>
              Nous nous r&eacute;servons le droit de modifier la pr&eacute;sente politique de confidentialit&eacute; &agrave; tout moment.
              Toute modification sera publi&eacute;e sur cette page avec la date de mise &agrave; jour.
            </p>
            <p className="mt-2 text-xs text-slate-400">Derni&egrave;re mise &agrave; jour : Mars 2026</p>
          </section>
        </div>
      </main>

      <footer className="border-t border-slate-100 py-6 px-6">
        <div className="max-w-4xl mx-auto flex flex-wrap items-center justify-center gap-4 text-xs text-slate-400">
          <Link to="/mentions-legales" className="hover:text-blue-600">Mentions l&eacute;gales</Link>
          <span>&middot;</span>
          <Link to="/politique-confidentialite" className="hover:text-blue-600">Politique de confidentialit&eacute;</Link>
          <span>&middot;</span>
          <Link to="/cgu" className="hover:text-blue-600">CGU</Link>
        </div>
      </footer>
    </div>
  );
}
